import React, { useState, useRef, useContext } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { UserContext } from "../providers/UserProvider";

import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import firebase from "firebase/app";

import { signInWithGoogle } from "../firebase";
import { auth } from "../firebase";
import { firestore } from "../firebase";

// import { login } from "../actions/auth";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const Login = () => {

  const astate = useContext(UserContext);

  const form = useRef();
  const checkBtn = useRef();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  {/* const { isLoggedIn } = useSelector(state => state.auth); */}
  {/* const { message } = useSelector(state => state.message); */}
  const [message, setMessage] = useState("");
  {/* const dispatch = useDispatch(); */}

  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleLogin = (e) => {
    e.preventDefault();

    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      firebase.auth().signInWithEmailAndPassword(email, password)
      .then(result => {
        // const userRef = firestore.doc(`users/${result.user.uid}`);
        // const snapshot = userRef.get();
        // console.log(snapshot);
        // console.log(result);
        // if (!result.user.emailVerified) {
        //   // auth.signOut();
        //   setMessage("mail not verified");
        //   setLoading(false);
        // }
        setLoading(false);
      })
      .catch(error => {
        // Update the error
        // console.log(error.message);
        setMessage(error.message);
        setLoading(false);
      })
    } else {
      setLoading(false);
    }
  };


  return (
    <div className="container">
      <div className="row">
        <div className="col-md-4"></div>
        <div className="col-md-4">
          <div className="login-card card-container">
            <img
              src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
              alt="profile-img"
              className="profile-img-card"
            />

            <Form onSubmit={handleLogin} ref={form}>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <Input
                  type="text"
                  className="form-control"
                  name="email"
                  value={email}
                  onChange={onChangeEmail}
                  validations={[required]}
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <Input
                  type="password"
                  className="form-control"
                  name="password"
                  value={password}
                  onChange={onChangePassword}
                  validations={[required]}
                />
              </div>

              <div className="form-group">
                <button
                  className="btn btn-primary btn-block"
                  disabled={loading}>
                  {loading && (
                    <span className="spinner-border spinner-border-sm"></span>
                  )}
                  <span>Login</span>
                </button>
              </div>
              {message && (
                <div className="form-group">
                  <div className="alert alert-danger" role="alert">
                    {message}
                  </div>
                </div>
              )}
              <CheckButton style={{ display: "none" }} ref={checkBtn} />
            </Form>

            <div className="form-group">
              <p className="text-center">OR</p>
            </div>

            <div className="form-group">
              <button
                className="btn btn-primary btn-block"
                onClick={() => {
                  signInWithGoogle();
                }}
              >
                Sign in with Google
              </button>
            </div>


          </div>
        </div>
        <div className="col-md-4"></div>
      </div>
    </div>
  );
};

export default Login;
